import TextAnswer from '@/components/shared/answer-types/text/text.vue';
import SelectListAnswer from '@/components/shared/answer-types/select-list/select-list.vue';
import NumberAnswer from '@/components/shared/answer-types/number/number.vue';
import CheckBoxAnswer from '@/components/shared/answer-types/checkbox/checkbox.vue';
import {
    YES_NO_OPTIONS,
    JUNIOR_MEMBERSHIP_TYPES,
    MAX_CLUB_MEMBERS,
    MIN_CLUB_MEMBERS,
    DEFAULTS
} from '../../constants/club-registration-constants.js';

export default {
    name: 'JuniorMembersSection',

    components: {
        'text-answer': TextAnswer,
        'select-list-answer': SelectListAnswer,
        'number-answer': NumberAnswer,
        'checkbox-answer': CheckBoxAnswer
    },

    props: {
        club: {
            type: Object,
            required: true
        },
        validation: {
            type: Object,
            required: true
        },
        readOnly: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            defaults: DEFAULTS,
            maxMembers: MAX_CLUB_MEMBERS,
            minMembers: MIN_CLUB_MEMBERS,
            hasJuniorMembersOptions: YES_NO_OPTIONS,
            juniorMembershipTypes: JUNIOR_MEMBERSHIP_TYPES
        };
    },

    computed: {
        localClub: {
            get() { return this.club; },
            set(value) { this.$emit('update:club', value); }
        },
        localValidation: {
            get() { return this.validation; },
            set(value) { this.$emit('update:validation', value); }
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/user/dashboard/pages/clubs/register-club/sections/junior-members-section/junior-members-section.js